import { ILoadingStation } from "../interfaces/loading-station.interface";

export class LoadingStation implements ILoadingStation {
  loadingstationName: string;
  marketname: string;

  constructor(loadingStation: ILoadingStation) {
    Object.keys(loadingStation).map(key => this[key] = loadingStation[key]);
  }
  
  get name(): string {
    return this.loadingstationName;
  }
}